import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BllTooltipComponent } from './tooltip.component';
import { BllHintModule } from '../hint';

@NgModule({
  imports: [CommonModule, BllHintModule],
  declarations: [BllTooltipComponent],
  exports: [BllTooltipComponent],
})
export class BllTooltipModule {}
